export default __webpack_public_path__ + "static/media/restartIcon.ddc96889.svg";